import FormLeaveConfirm from './FormLeaveConfirm'

export default FormLeaveConfirm;